var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3906 6.41225C10.5078 6.33412 10.625 6.33412 10.7812 6.37318L19.3359 8.83412L24.9609 6.5685C25.5469 6.33412 26.25 6.76381 26.25 7.42787V20.5138C26.25 20.9044 26.0156 21.256 25.625 21.3732L19.5703 23.7951C19.4531 23.8732 19.3359 23.8732 19.1797 23.8341L10.625 21.3732L5 23.6388C4.41406 23.8732 3.75 23.4435 3.75 22.7794V9.6935C3.75 9.30287 3.94531 8.95131 4.33594 8.83412L10.3906 6.41225ZM5 22.3107L10 20.3185V7.89662L5 9.88881V22.3107ZM18.75 9.96693L11.25 7.8185V20.2404L18.75 22.3888V9.96693ZM20 22.3107L25 20.3185V7.89662L20 9.88881V22.3107Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapDark);
export default __webpack_public_path__ + "static/media/map-dark.81f6f93f2437a90b834d61ee5e45db8b.svg";
export { ForwardRef as ReactComponent };